const SecureStorage = {
  // Encrypt data before storing
  encrypt(data) {
    try {
      return btoa(encodeURIComponent(JSON.stringify(data)));
    } catch {
      return null;
    }
  },

  // Decrypt stored data
  decrypt(data) {
    try {
      return JSON.parse(decodeURIComponent(atob(data)));
    } catch {
      return null;
    }
  },

  // Store data securely
  setItem(key, value) {
    const encrypted = this.encrypt(value);
    if (encrypted) {
      sessionStorage.setItem(key, encrypted);
      return true;
    }
    return false;
  },

  // Get stored data
  getItem(key) {
    const value = sessionStorage.getItem(key);
    if (!value) return null;
    return this.decrypt(value);
  },

  // Remove item
  removeItem(key) {
    sessionStorage.removeItem(key);
  },

  // Clear all storage
  clear() {
    sessionStorage.clear();
  },

  // Store auth data
  setAuthData(data, isAdmin = false) {
    let authData;
    if (isAdmin) {
      authData = {
        role: 'admin',
        userId: data.userId,
        role_id: '1',
        authorized: true,  // Add authorized flag for admin
        token: data.token  // Keep the token for admin
      };
    } else {
      authData = {
        customerCode: data.customerCode,
        email: data.email,
        authorized: data.authorized,
        role: data.role,
        token: data.token,
        userId: data.userId,
        buyerName: data.buyerName,
        property: data.property
      };
    }

    this.setItem('auth', authData);

    if (!isAdmin && data.output) {
      this.setItem('authOutput', data.output);
    }
  },

  // Simplified isLoggedIn check since both admin and client will have authorized
  isLoggedIn() {
    const auth = this.getItem('auth');
    return !!(auth && auth.authorized);
  },

  // Add method to check auth status
  isAuthenticated() {
    const auth = this.getItem('auth');
    return !!(auth && auth.authorized && auth.token);
  }
};

export default SecureStorage;
